import React from "react";
import GestureButton from "./GestureButton";
import { Action } from "../karaoke/actions";

export default function PlayControl({ activeAction, onTrigger, className }) {
  return (
    <GestureButton
      action={Action.PLAY}
      label="Play"
      emoji="✋"
      activeAction={activeAction}
      onTrigger={onTrigger}
      className={className}
    />
  );
}
